import { QueryClient } from '@tanstack/react-query';

/**
 * El `QueryClient` de la app, en su propio módulo.
 *
 * Vivía adentro de `App.tsx`, que es el lugar natural mientras el único que lo
 * necesita es el árbol de React. Dejó de serlo cuando la cola de envío pasó a
 * tener una **consecuencia**: si algo salió de la cola, lo que el servidor sabe
 * cambió y `mi` quedó viejo. Esa consecuencia es una sola y tiene que valer para
 * los tres disparadores del vaciado —abrir la app, volver la conexión, entrar—,
 * así que vive al lado del vaciado y no en cada pantalla que lo llama. Para eso
 * el cliente tiene que poder importarse sin importar la app entera.
 *
 * Los reintentos están acotados a dos: el público de esta app está en una red
 * móvil que se cae, y reintentar indefinidamente deja la pantalla girando sin
 * decir nada. Dos intentos y después se muestra el error, con su botón.
 */
export const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

/** La clave de todo lo que el paciente ve de sí mismo. */
export const CLAVE_DE_MI = ['mi'] as const;
